import styled from 'styled-components';
import {
  ModalBody
} from '@one-thd/sui-atomic-components';
import {
  mobileMaxWidth,
  desktop,
  tablet,
} from '../../utils/constants';

export const FormContainer = styled.div`
  padding-top: 2.5rem;

  @media all and (max-width: ${mobileMaxWidth}) {
  }

  @media all and (min-width: ${tablet}) {
   
  }
`;

export const RoomContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  & > button {
    margin-top: 1.6rem;

    @media all and (min-width: ${tablet}) {
      @supports(-webkit-touch-callout: none) {
        margin-top: 1.8rem;
      }
    }
  }

  & > #addRoomButton {
    margin-left: 1rem;
    flex: 0 1 auto;

    @media all and (min-width: ${desktop}) {
      width: 28.5rem;
    }

    @media all and (max-width: ${mobileMaxWidth}) {
      margin-left: 0;
    }
  }

  @media all and (max-width: ${mobileMaxWidth}){
    flex-wrap: wrap;
  }
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  flex: 0 1 auto;
  width: 100%;
  max-width: 60%;

  & > div {
    padding-right: 1rem;

    &:last-child {
      padding-right: 0;
    }
  }

  @media all and (min-width: ${desktop}) {
    max-width: ${(props) => (props.isEdit ? '60%' : '80%')};
  }

  @media all and (max-width: ${mobileMaxWidth}) {
    max-width: 100%;
  }

  @media all and (max-width: 520px) {
    flex-wrap: wrap;
  }
`;

export const CustomBody = styled(ModalBody)`
  width: 100%
`;

export const Form = styled.form`
 
  @media all and (min-width: ${desktop}) {
    width: 100%;
    display: flex
  }

  @media all and (min-width: ${tablet}) {
    width: 100%;
    display: flex
  }

  @media all and (max-width: ${mobileMaxWidth}) {
    flex-direction: column;
    
  }

`;

export const MobileForm = styled.div`
    display: flex;

    @media all and (min-width: ${desktop}) {
      gap: 16px;
      width: 50%;
      padding-left: inherit;
      justify-content: right;
    }

    @media all and (max-width: ${mobileMaxWidth}) {
      gap: 0.5rem;
    }
`;

export const InputWrapper = styled.div`
  width: 50%;
  & > input {
    box-sizing: border-box;
    border-radius: 3px;
    padding: 0.2rem 0.5rem;
    height: 4rem;
  }
  @media all and (min-width: ${desktop}) {
    justify-content: left;
    width: 50%;
  }

  @media all and (min-width: ${tablet}) {
    justify-content: left;
    width: 50%;
  }

  @media all and (max-width: ${mobileMaxWidth}){
    width: 100%;
  }

  @media all and (max-width: 520px) {
    &&& {
      padding-right: 0;
      padding-bottom: 1rem;
    }
  }
`;

export const InputWrapperNumber = styled.div`
  display: flex;
  flex-direction: column;
  width: 33.33%;

  & > input {
    box-sizing: border-box;
    border-radius: 3px;
    padding: 0.2rem 0.5rem;
    height: 4rem;
  }

  @media all and (min-width: ${desktop}) {
    width: 45%;
  }

  @media all and (min-width: ${tablet}) {
    width: 45%;
  }

  @media all and (max-width: ${mobileMaxWidth}) {
    width: 49%;
  }

  @media all and (max-width: 520px) {
    width: 49%;
  }
`;

export const EditButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: 1.6rem;
  flex: 1 0 auto;
  padding-left: 1rem;

  @media all and (min-width: ${tablet}) {
      @supports(-webkit-touch-callout: none) {
        padding-top: 1.8rem;
      }
    }

  & > button {
    width: 100%;

    &.secondary{
      margin-left: 1rem;

      @media all and (max-width: 520px) {
        margin-left: 0;
      }
    }
  }

  @media all and (max-width: ${mobileMaxWidth}) {
    width: 100%;
    padding-top: 1.5rem;
    padding-left: 0;
  }

  @media all and (max-width: 520px) {
    flex-wrap: wrap;

    & > button {
      &:first-child {
        margin-bottom: 1rem;
      }
    }
  }
`;
